import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Offcanvas, Button } from "react-bootstrap";
import { LogoFull } from "../../assets/icons/logoFull";
import { UserMenu } from "../Header/UserMenu";
import { NavigationMenu } from "./NavigationMenu";

export const MobileDrawer = () => {
  const [show, setShow] = useState(false);
  const location = useLocation();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // Close the drawer when location changes (user navigates to a new page)
  useEffect(() => {
    handleClose();
  }, [location.pathname]);

  return (
    <>
      <Button
        variant="none"
        className="d-lg-none px-1 py-0 d-flex align-items-center"
        onClick={handleShow}
        aria-label="Open menu"
      >
        <i className="bi bi-list fs-1" aria-hidden="true"></i>
      </Button>

      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="start"
        className="mobile-drawer nav-menu"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <Link to="/" className="text-decoration-none" onClick={handleClose}>
              <LogoFull width="180" height="40" />
            </Link>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="d-flex flex-column">
          <div className="flex-grow-1">
            <NavigationMenu />
          </div>
          <div className="mt-auto">
            <UserMenu />
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};
